import FetchService from "./Shared/FetchService";
import MeetingRequestDomainService from "../Domain/MeetingRequest/MeetingRequest.service";
const BASE_URL = "/aviso/advisor";
let tabPermissionsPromise = null;
export default class AdvisorService {
    static search(query, max) {
        return FetchService.get(BASE_URL + "/search", { q: query, max });
    }
    static assignAdvisor(studentAffiliationId, advisorAffiliationId) {
        return FetchService.postSingleResponse(BASE_URL + "/assignAdvisor", {
            studentAffiliationId,
            advisorAffiliationId,
        });
    }
    static getTags() {
        return FetchService.getSingleArrayResponse(BASE_URL + "/getTags");
    }
    static getRiskLevels() {
        return FetchService.getSingleArrayResponse(BASE_URL + "/getRiskLevels");
    }
    static getPrograms() {
        return FetchService.getSingleArrayResponse(BASE_URL + "/getPrograms");
    }
    static getDegrees() {
        return FetchService.getSingleArrayResponse(BASE_URL + "/getDegrees");
    }
    static getTermForAdvisor() {
        return FetchService.getSingleResponse(BASE_URL + "/getTermToRepresentAdvisor");
    }
    static getTermForCoach() {
        return FetchService.getSingleResponse(BASE_URL + "/getTermToRepresentCoach");
    }
    /**
     * @deprecated use useHasPermission
     */
    static getPermissions() {
        return FetchService.getSingleResponse(BASE_URL + "/getPermissions");
    }
    static getTabPermissions() {
        if (!tabPermissionsPromise) {
            tabPermissionsPromise = FetchService.getSingleResponse(BASE_URL + "/getTabPermissions");
        }
        return tabPermissionsPromise;
    }
    static lookupFromList(term) {
        return FetchService.post(BASE_URL + "/lookupFromList", {
            term,
        });
    }
    static getAllSettings() {
        return FetchService.get(BASE_URL + "/allSettings");
    }
    static getIsFollowingStudents() {
        return FetchService.getSingleResponse(BASE_URL + "/isFollowingStudents");
    }
    static getMessageFromEmailAddressesAsList() {
        return FetchService.getSingleArrayResponse(BASE_URL + "/getMessageFromEmailAddressesAsList");
    }
    static getMeetingRequestList() {
        return FetchService.get(BASE_URL + "/getMeetingRequestList").then((response) => (Object.assign(Object.assign({}, response), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            meetingRequests: response.meetingRequests.map(MeetingRequestDomainService.fromJSON) })));
    }
    static isPersonOnCurrentUsersCase(affiliationId) {
        return FetchService.getSingleResponse(BASE_URL + "/isPersonOnCurrentUsersCase?affiliationId=" + affiliationId);
    }
}
